import { $apiV5 } from "@plugins/axios";
const API = {
  subjects: {
    getBuyCost: "/subjects/users/:subjectOwner/:amount/buy-cost",
    getSellCost: "/subjects/users/:subjectOwner/:amount/sell-cost",
    summary: "/subjects/users/:subjectOwner/summary",
    holders: "/subjects/users/:subjectOwner/holders",
    history: "/subjects/users/:subjectOwner/historical",
  },
};

export const getBuyCost = async (subjectOwner, amount) => {
  try {
    const url = getApiPath(API.subjects.getBuyCost, {
      subjectOwner: subjectOwner,
      amount: amount,
    });
    const { data } = await $apiV5.get(url);
    return data.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};

export const getSellCost = async (subjectOwner, amount) => {
  try {
    const url = getApiPath(API.subjects.getSellCost, {
      subjectOwner: subjectOwner,
      amount: amount,
    });
    const { data } = await $apiV5.get(url);
    return data.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};

export const getSubjectSummary = async (subjectOwner) => {
  try {
    const url = getApiPath(API.subjects.summary, {
      subjectOwner: subjectOwner,
    });
    const { data } = await $apiV5.get(url);
    return data.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};

export const getSubjectHolder = async (subjectOwner) => {
  try {
    const url = getApiPath(API.subjects.holders, {
      subjectOwner: subjectOwner,
    });
    const { data } = await $apiV5.get(url);
    return data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};

export const getSubjectHistory = async (subjectOwner, params) => {
  try {
    const url = getApiPath(API.subjects.history, {
      subjectOwner: subjectOwner,
    });
    const { data } = await $apiV5.get(url, { params });
    return data.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};
